import { Dropdown } from "react-bootstrap";
import { IDoctorPlaces } from "../../../../../types/doctor";

interface IPlacesCard {
  locals: IDoctorPlaces[];
  selected: number;
  setSelected: (num: number) => void;
}

export const PlacesCard = ({ locals, selected, setSelected }: IPlacesCard) => {
  return (
    <Dropdown className="d-grid mb-4">
      <>
        <Dropdown.Toggle
          variant="btn btn-outline-secondary"
          className="text-start rounded-4 bg-white text-wrap px-3 py-2"
        >
          {locals.map((elm, i) => (
            <div key={i} style={selected !== i ? { display: "none" } : {}}>
              {selected === i && (
                <div
                  key={i}
                  className="row g-0 align-items-center flex-nowrap w-100"
                >
                  <div className="col">
                    <h6 className="mb-1">{elm.name}</h6>
                    <p className="opacity-50 small mb-0">
                      <small>
                        {elm.addressName}, {elm.number} <br /> CEP: {elm.cep}{" "}
                        {elm.neighborhood} - {elm.city}/{elm.state}
                      </small>
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </Dropdown.Toggle>

        <Dropdown.Menu className="w-100">
          {locals.map((elm, i) => (
            <Dropdown.Item
              key={i}
              onClick={() => setSelected(i)}
              className="text-wrap"
              active={selected === i}
            >
              <div className="row g-0 align-items-center flex-nowrap w-100">
                <div className="col">
                  <h6 className="mb-1">{elm.name}</h6>
                  <p className="opacity-50 small mb-0">
                    <small>
                      {elm.addressName}, {elm.number} <br /> CEP: {elm.cep}{" "}
                      {elm.neighborhood} - {elm.city}/{elm.state}
                    </small>
                  </p>
                </div>
              </div>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </>
    </Dropdown>
  );
};
